module.exports = __webpack_public_path__ + "static/image/history/pc/202404.ver2_0_2.png?eec6c563";